import { Pipe, PipeTransform } from '@angular/core';
/*
 * Formats a file size in bytes into a human-readable string (e.g., Bytes, KB, MB).
 * "bytes" is the number to format, representing the file size in bytes.
 * Returns a string with the formatted size and unit (e.g., "1.18 MB").
 * Usage:
 *  Import the pipe, declare it in your Angular module, and apply it in templates with "| fileSize".
 */
@Pipe({
  name: 'formatFileSize',
  standalone: false,
})
export class FormatFileSize implements PipeTransform {
  transform(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
